export default __webpack_public_path__ + "static/media/notifications-empty-light.5c73a731.png";